const ListSearchSubscriptionBirthDate = ({setSearchMonth, searchMonth}) => {
  return (
    <div className='mb-5 row'>
      <div className='col-12'>
        <label className='form-label fs-6 fw-bold'>Pesquisar por Data de Nascimento: </label>
        <select
          className='form-select form-select-lg form-select-solid'
          value={searchMonth}
          onChange={(e) => setSearchMonth(e.target.value)}
        >
          <option value=''>Selecione o mês</option>
          <option value='1'>Janeiro</option>
          <option value='2'>Fevereiro</option>
          <option value='3'>Março</option>
          <option value='4'>Abril</option>
          <option value='5'>Maio</option>
          <option value='6'>Junho</option>
          <option value='7'>Julho</option>
          <option value='8'>Agosto</option>
          <option value='9'>Setembro</option>
          <option value='10'>Outubro</option>
          <option value='11'>Novembro</option>
          <option value='12'>Dezembro</option>
        </select>
      </div>
    </div>
  )
}

export {ListSearchSubscriptionBirthDate}
